module.exports = __webpack_public_path__ + "static/media/image2.68270c0f.png";